import { render } from "./Board.vue?vue&type=template&id=6dac3856&scoped=true"
import script from "./Board.vue?vue&type=script&lang=ts"
export * from "./Board.vue?vue&type=script&lang=ts"

import "./Board.vue?vue&type=style&index=0&id=6dac3856&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6dac3856"

export default script